const AddNewStaffIcon = ({
  height = "40px",
  width = "40px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
        viewBox="0 0 40 40"
        fill="none"
      >
        <g clipPath="url(#clip0_699_5824)">
          <path
            d="M32 0.5H8C3.85786 0.5 0.5 3.85786 0.5 8V32C0.5 36.1421 3.85786 39.5 8 39.5H32C36.1421 39.5 39.5 36.1421 39.5 32V8C39.5 3.85786 36.1421 0.5 32 0.5Z"
            fill="white"
            stroke="#E9EEFE"
          />
          <mask
            id="mask0_699_5824"
            mask-type="luminance"
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="24"
          >
            <path d="M32 8H8V32H32V8Z" fill="white" />
          </mask>
          <g mask="url(#mask0_699_5824)">
            <mask
              id="mask1_699_5824"
              mask-type="luminance"
              maskUnits="userSpaceOnUse"
              x="8"
              y="8"
              width="24"
              height="24"
            >
              <path d="M32 8H8V32H32V8Z" fill="white" />
            </mask>
            <g mask="url(#mask1_699_5824)">
              <path
                d="M20.3125 30.963C18.5275 31.0071 15.0203 30.7286 13.8742 30.4572C13.0928 30.2927 12.3583 29.838 11.8052 29.2052C11.2521 28.5724 10.9024 27.79 10.8208 26.9993L10.818 26.9749C10.7591 26.3845 10.7415 25.7907 10.7655 25.1979C10.7655 25.1979 10.7214 24.6743 10.8208 23.725C10.8208 23.7171 10.8208 23.7086 10.8208 23.7007C10.9045 22.9212 11.2533 22.1941 11.8089 21.641C12.3674 21.082 13.0993 20.7296 13.8846 20.6416C15.0344 20.5202 18.5332 20.4541 20.3116 20.4541C22.09 20.4541 24.9438 20.5202 26.0936 20.6416C26.8788 20.7297 27.6107 21.0821 28.1692 21.641C28.7255 22.1947 29.0742 22.923 29.1569 23.7035V23.7274C29.2563 24.6771 29.2432 25.1983 29.2432 25.1983C29.2459 25.7932 29.2173 26.3877 29.1574 26.9796C29.1574 26.9875 29.1574 26.9955 29.155 27.0035C29.0735 27.7943 28.7242 28.5757 28.1707 29.2099C27.6171 29.8441 26.8825 30.2969 26.1011 30.4614C24.9569 30.7193 22.0971 30.9752 20.3125 30.963Z"
                fill="#183883"
              />
              <path
                d="M25.5598 20.5961C24.2135 20.5023 21.8567 20.4531 20.3098 20.4531C18.5313 20.4531 15.0326 20.5197 13.8828 20.6406C13.0981 20.7292 12.3669 21.0817 11.809 21.6405C11.2536 22.1936 10.9049 22.9207 10.8213 23.7002V23.7245C10.7187 24.6737 10.7656 25.1973 10.7656 25.1973C10.7424 25.7902 10.7607 26.384 10.8204 26.9744L10.8232 26.9987C10.8709 27.4429 10.9958 27.8753 11.1921 28.2766C12.0834 28.4735 12.9934 28.5726 13.9062 28.5723C19.212 28.5723 23.7467 25.2634 25.5598 20.5961Z"
                fill="#5170CD"
              />
              <path
                d="M19.8841 19.1178C22.9542 19.1178 25.443 16.629 25.443 13.5589C25.443 10.4888 22.9542 8 19.8841 8C16.814 8 14.3252 10.4888 14.3252 13.5589C14.3252 16.629 16.814 19.1178 19.8841 19.1178Z"
                fill="#E62D38"
              />
              <path
                d="M27.2223 22.4453C26.2774 22.4453 25.3537 22.7255 24.5681 23.2505C23.7824 23.7754 23.1701 24.5216 22.8085 25.3945C22.4469 26.2675 22.3523 27.2281 22.5366 28.1549C22.721 29.0816 23.176 29.9329 23.8441 30.601C24.5123 31.2692 25.3635 31.7242 26.2903 31.9085C27.217 32.0929 28.1776 31.9982 29.0506 31.6366C29.9236 31.275 30.6697 30.6627 31.1947 29.877C31.7196 29.0914 31.9998 28.1677 31.9998 27.2228C31.9998 25.9557 31.4965 24.7406 30.6005 23.8446C29.7046 22.9487 28.4894 22.4453 27.2223 22.4453Z"
                fill="#FDCE2F"
              />
              <path
                d="M29.2812 28.1135H28.113V29.2816C28.113 29.5178 28.0192 29.7444 27.8522 29.9114C27.6852 30.0784 27.4586 30.1723 27.2224 30.1723C26.9862 30.1723 26.7597 30.0784 26.5927 29.9114C26.4256 29.7444 26.3318 29.5178 26.3318 29.2816V28.1135H25.166C24.9298 28.1135 24.7033 28.0197 24.5362 27.8527C24.3692 27.6856 24.2754 27.4591 24.2754 27.2229C24.2754 26.9867 24.3692 26.7601 24.5362 26.5931C24.7033 26.4261 24.9298 26.3323 25.166 26.3323H26.3318V25.166C26.3318 24.9298 26.4256 24.7033 26.5927 24.5362C26.7597 24.3692 26.9862 24.2754 27.2224 24.2754C27.4586 24.2754 27.6852 24.3692 27.8522 24.5362C28.0192 24.7033 28.113 24.9298 28.113 25.166V26.3323H29.2812C29.5174 26.3323 29.7439 26.4261 29.9109 26.5931C30.078 26.7601 30.1718 26.9867 30.1718 27.2229C30.1718 27.4591 30.078 27.6856 29.9109 27.8527C29.7439 28.0197 29.5174 28.1135 29.2812 28.1135Z"
                fill="white"
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_699_5824">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default AddNewStaffIcon;
